export enum ServiceDetailRoutesPath {
  OBTENIR_LHISTORIQUE_DUN_VEHICULE = 'obtenir-lhistorique-dun-vehicule',
  ESTIMER_LE_PRIX_DE_VOTRE_VEHICULE = 'estimer-le-prix-de-votre-vehicule',
  ANALYSER_LE_KILOMETRAGE_DUN_VEHICULE = 'analyser-le-kilometrage-dun-vehicule',
}
